import script from "./tag-links.vue?vue&type=script&lang=js"
export * from "./tag-links.vue?vue&type=script&lang=js"

import "./tag-links.vue?vue&type=style&index=0&id=21ce0018&lang=scss"

const __exports__ = script;

export default __exports__